<template>
    <div class="playbackList-wrapper">
        <div class="loading" v-show="loading">
            <van-loading type="spinner" color="#fff"/>
        </div>
        <div class="playbackList-wrapper--header">
            <!-- <img src="../../assets/image/fanhui.png" alt="" @click="$router.go(-1)"> -->
            <div class="goBack" @click="$router.go(-1)"></div>
            <div class="plateNumber">轨迹回放-{{plateNumber}}</div>
            <div class="screen" @click="popupFlag = true">
                筛选
                <div class="sx"></div>
            </div>
        </div>
        <div class="playbackList-wrapper--title">近20天行程</div>
        <div class="playbackList-wrapper--list">
            <div class="item" @click="trackPlayback(index,item.startTime,item.endTime)" v-for="(item,index) in travelList" :key="`${index}a`">
                <div class="carDes">
                    <div class="tripDate">
                        <img src="../../assets/image/carLogo.png" alt="">
                        {{ item.statisticsDate }}  {{ item.startTime | substrTime }}  -  {{ item.endTime | substrTime }}
                    </div>
                    <div class="tripAddress">
                        <div class="marks">
                            <div class="circleGreen"></div>
                            <div class="line"></div>
                            <div class="circlePink"></div>
                        </div>
                        <div class="value"> 
                            <p style="margin-bottom:5px">{{ item.startAddress }}</p>
                            <p>{{ item.endAddress }}</p>
                        </div>
                    </div>
                </div>
                <div class="carMsg">
                    <div class="carMsg-item">
                        <div class="value">{{ parseInt(item.avgSpeed) }}<span>km/h</span></div>
                        <div class="label">平均速度</div>
                    </div>
                    <div class="carMsg-item">
                        <div class="value">{{ parseInt(item.maxSpeed) }}<span>km/h</span></div>
                        <div class="label">最高速度</div>
                    </div>
                    <div class="carMsg-item">
                        <div class="value">{{ item.mileage }}<span>km</span></div>
                        <div class="label">行驶里程</div>
                    </div>
                    <div class="carMsg-item">
                        <div class="value">{{parseInt(item.driveTime/60/60)}}<span>h</span>{{parseInt(item.driveTime/60%60)}}<span>m</span></div>
                        <div class="label">行驶时长</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup" v-show="popupFlag">
            <div class="popup-container">
                <div class="title">快速查询</div>
                <div class="dateArea">
                    <div :class="{'active':timeType==1}" @click="getSearchTime(1)">近一天</div>
                    <div :class="{'active':timeType==2}" @click="getSearchTime(2)">近三天</div>
                    <div :class="{'active':timeType==3}" @click="getSearchTime(3)">近七天</div>
                </div>
                <div class="title">自定义查询</div>
                <div class="datePicker">
                    <div class="setDate" @click="chooseDate(0)">{{startDate}}</div>
                    <div class="line"></div>
                    <div class="setDate" @click="chooseDate(1)" :disabled="!    startDate">{{endDate}}</div>
                </div>
            </div>
            <div class="popup-footer">
                <div class="left" @click="cancel">取消</div>
                <div class="right" @click="getTravelList">确认</div>
            </div>
        </div>
        <div class="overly" v-show="popupFlag" @click="popupFlag=false"></div>
        <van-popup v-model="showPicker" round position="bottom">
            <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年月日"
            @confirm="finishChoose"
            @cancel="showPicker=false"
            />
        </van-popup>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading:false,
            key:'',
            popupFlag: false,
            // minDate: new Date(2018, 1, 1),
            // maxDate: new Date(2025, 10, 1),
            currentDate: new Date(),
            startDate: '',
            endDate: '',
            showPicker: false,
            dateFlag: 0,
            timeType: '',
            travelList:[],
            plateNumber:''
        }
    },
    mounted() {
        // let time = new Date()
        // this.currentDate = this.dateFormate(time)
        this.key = this.$route.query.key
        this.plateNumber = this.$route.query.plateNumber
        this.getTravelList()
    },
    filters: {
        substrTime(time) {
            let time1 = new Date(time.replace(/-/g, "/"))
            let H = time1.getHours()<10?'0'+time1.getHours():time1.getHours()
            let M = time1.getMinutes()<10?'0'+time1.getMinutes():time1.getMinutes()
            let getTime = H+':'+M
            return getTime
        }
    },
    methods: {
        async getTravelList() {
            this.loading = true
            const data = await this.$api.getTravelList(this.key,
                {beginTime: this.startDate, endTime: this.endDate})
            this.travelList = data.datas.content
            this.loading = false
            this.cancel()
        },
        cancel() {
            this.startDate = ''
            this.endDate = ''
            this.popupFlag = false
        },
        trackPlayback(index,beginTime,endTime) {
            this.$router.push({
                path:'/realtime/trackPlayback',
                query: {
                    beginTime,
                    endTime,
                    key:this.key
                }
            })
        },
        chooseDate(flag) {
            this.showPicker = true
            this.dateFlag = flag
        },
        finishChoose() {
            let chooseDate = this.dateFormate(this.currentDate)
            if(this.dateFlag==0) {
                this.startDate = chooseDate
            }else {
                this.endDate = chooseDate
            }
            this.showPicker=false
        },
        dateFormate(time) {
            let Y = time.getFullYear()
            let M = time.getMonth()+1
            let D = time.getDate()
            M = M < 10?'0'+M : M
            D = D < 10?'0'+D : D
            let chooseDate = Y + '-'+ M + '-' + D
            return chooseDate
        },
        getSearchTime(type) {
            const time = new Date().getTime()
            switch (type) {
                case 1:
                    this.timeType = 1
                    let d1 = new Date(time-1000*60*60*24)
                    this.startDate = this.dateFormate(d1)
                    this.endDate = this.dateFormate(d1)
                    break;
                case 2:
                    this.timeType = 2
                    let d2 = new Date(time-1000*60*60*24)
                    let d3 = new Date(time-1000*60*60*24*3)
                    this.startDate = this.dateFormate(d3)
                    this.endDate = this.dateFormate(d2)
                    break;
                case 3:
                    this.timeType = 3
                    let d4 = new Date(time-1000*60*60*24)
                    let d5 = new Date(time-1000*60*60*24*7)
                    this.startDate = this.dateFormate(d5)
                    this.endDate = this.dateFormate(d4)
                    break;
            }
        }
    }
}
</script>

<style lang="scss">
    .playbackList-wrapper {
        position: relative;
        // height: 100vh;
        overflow: hidden;
        background-color: #F5F5F5;
        .loading {
            position: fixed;
            width: 100%;
            height: 100%;
            z-index: 999;
            background-color:rgba(0,0,0,.5);
            display: flex;
            justify-content: center;
            align-items: center;
        }
        &--header {
            position: relative;
            height: 50px;
            padding: 12.5px 15px;
            box-sizing: border-box;
            text-align: center;
            background-image: linear-gradient(109deg, #EBF3F9 41%, #F3F7FB 99%);
            .goBack {
                position: absolute;
                top: 15px;
                left: 15px;
                width: 12px;
                height: 21.5px;
                background: url('~@/assets/image/fanhui.png') no-repeat;
                background-size: 100% 100%;
            }
            .plateNumber {
                height: 26.5px;
                line-height: 26.5px;
                display: inline-block;
                font-family: PingFangSC;
                font-weight: 700;
                font-size: 19px;
                color: #000000;
                vertical-align: middle;
            }
            .screen {
                position: absolute;
                top: 13.5px;
                right: 15px;
                width: 70px;
                height: 24.5px;
                line-height: 24.5px;
                background: #FFFFFF;
                border: 1px solid #484A50;/* px-to-viewport-ignore */
                border-radius: 12px;
                font-family: PingFangSC;
                font-weight: 700;
                font-size: 14px;
                color: #000000;
                .sx {
                    display: inline-block;
                    width: 13px;
                    height: 12px;
                    background: url('~@/assets/image/shaixuan.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
        &--title {
            height: 22.5px;/* px-to-viewport-ignore */
            line-height: 22.5px;
            margin: 10px 0;
            padding-left: 21px;
            font-family: PingFangSC;
            font-weight: 700;
            font-size: 16px;
            color: #2C2E34;
        }
        &--list {
            padding: 0 15px;
            min-height: calc(100vh - 72.5px);/* px-to-viewport-ignore */
            box-sizing: border-box;
            .item {
                height: 178px;
                background: #FFFFFF;
                box-shadow: 0 1px 11px 0 #E4E9EE;
                border-radius: 17px;
                margin-bottom: 15px;
                .carDes {
                    height: 118.5px;
                    box-sizing: border-box;
                    padding-left: 14.5px;
                    .tripDate {
                        height: 46px;
                        line-height: 46px;
                        box-sizing: border-box;
                        border-bottom: 1px solid rgba(203,208,214,.5);
                        font-family: PingFangSC;
                        font-weight: 700;
                        font-size: 13.5px;
                        color: #484A50;
                        img {
                            width: 21px;
                            height: 21px;
                            vertical-align: middle;
                            margin-right: 10px;
                        }
                    }
                    .tripAddress {
                        margin-top: 12.5px;
                        border-radius: 17px;
                        .marks {
                            display: inline-block;
                            width: 7px;
                            height: 42px;
                            box-sizing: border-box;
                            padding: 6px 0;
                            margin: 0 8px 0 4.5px;
                            .circleGreen {
                                width: 7px;
                                height: 7px;
                                border-radius: 50%;
                                background: #00D6A5;
                            }
                            .circlePink {
                                width: 7px;
                                height: 7px;
                                border-radius: 50%;
                                background: #FF5961;
                            }
                            .line {
                                width: 2px;
                                height: 16.5px;
                                background: #E5E7EA;
                                margin-left: 2.5px;
                            }
                        }
                        .value {
                            display: inline-block;
                            font-family: PingFangSC;
                            font-weight: 700;
                            font-size: 13px;
                            color: #2C2E34;
                            p {
                                display: block;
                                height: 18.5px;
                                line-height: 18.5px;
                                width: 340px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                }
                .carMsg {
                    height: calc(100% - 118.5px);
                    background: #F3F8FB;
                    border-radius: 8.5px;
                    display: flex;
                    box-sizing: border-box;
                    padding: 8.5px 0;
                    &-item {
                        flex: 1;
                        text-align: center;
                        .value {
                            font-family: DINAlternate;
                            font-size: 20px;
                            font-weight: 700;
                            color: #414852;
                            height: 23.5px;
                            line-height: 23.5px;
                            margin-bottom: 1px;
                            span {
                                font-family: PingFangSC-Regular;
                                font-size: 10px;
                                font-weight: normal;
                                color: #4A4E53;
                            }
                        }
                        .label {
                            font-family: PingFangSC-Regular;
                            font-size: 12.5px;
                            color: #484A50;
                            height: 18px;
                            line-height: 18px;
                        }
                    }
                }
            }
        }
        .popup {
            height: 276px;
            position: absolute;
            top: 50px;
            width: 100vw;
            background-color: #fff;
            &-container {
                height: calc(100% - 46px);
                box-sizing: border-box;
                padding: 2px 15px 0;
                .title {
                    height: 45px;
                    line-height: 45px;
                    font-family: PingFangSC;
                    font-weight: 700;
                    font-size: 14px;
                    color: #2C2E34;
                }
                .dateArea {
                    height: 41px;
                    margin-bottom: 8.5px;
                    &>div {
                        width: 121px;
                        height: 41px;
                        line-height: 41px;
                        text-align: center;
                        background: #F4F6F7;
                        border-radius: 3.5px;
                        display: inline-block;
                        margin-right: 10.5px;
                        font-family: PingFangSC-Regular;
                        font-size: 15px;
                        color: #2C2E34;
                        &:last-child {
                            margin-right: 0px;
                        }
                        &.active {
                            background-color: #00B38A;
                            color: #fff;
                        }
                    }
                }
                .datePicker {
                    height: 41px;
                    display: flex;
                    &>div {
                        display: inline-block;
                    }
                    .line {
                        width: 41px;
                        height: 1px;
                        margin: 20px 5px;
                        background: #D8D8D8;
                    }
                    .setDate {
                        flex: 1;
                        height: 41px;
                        line-height: 41px;
                        padding-left: 12px;
                        background: #F4F6F7;
                        border-radius: 7px;
                        font-family: PingFangSC;
                        font-weight: 700;
                        font-size: 15px;
                        color: #BFBFBF;
                    }
                }
            }
            &-footer {
                height: 46px;
                &>div {
                    display: inline-block;
                    width: 50vw;
                    height: 46px;
                    line-height: 46px;
                    text-align: center; 
                    font-family: PingFangSC;
                    font-weight: 700;
                    font-size: 17px;
                }
                .left {
                    background: rgba(0,179,138,.1);
                    color: #00B38A;
                }
                .right {
                    background: #00B38A;
                    color: #fff;
                }
            }
        }
        .overly {
            height: calc(100% - 326px);
            position: absolute;
            top: 326px;
            width: 100vw;
            background-color: rgba(0,0,0,0.4);
        }
    }
</style>